import { render, staticRenderFns } from "./Standalone.vue?vue&type=template&id=0942c942&"
import script from "./Standalone.vue?vue&type=script&lang=ts&"
export * from "./Standalone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0942c942')) {
      api.createRecord('0942c942', component.options)
    } else {
      api.reload('0942c942', component.options)
    }
    module.hot.accept("./Standalone.vue?vue&type=template&id=0942c942&", function () {
      api.rerender('0942c942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/apps/Standalone.vue"
export default component.exports